export default "__VITE_ASSET__8eb4e885__"